import React from 'react';
import ReactDOM from 'react-dom/client';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';

import ConnectionData from './ConnectionData';
import ConnectionDataTabState from './ConnectionDataTabState';

export default class ConnectionDataTabView extends BufferTabView<ConnectionDataTabState> {
  reactRoot: ReactDOM.Root | null = null;

  override render(): this {
    const props = {
      connectionId: this.model.get('connectionId'),
    };
    this.reactRoot = renderToDOM(<ConnectionData {...props} />, this.el, this.reactRoot);
    return this;
  }

  override removeAsync(callback: () => void): BufferTabView<ConnectionDataTabState> {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}

ConnectionDataTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
